(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kd-footer"] && !Shopify.designMode) return;
  try {
    
 if (!customElements.get('kd-footer-country')) {
  customElements.define('kd-footer-country', class extends HTMLElement {
   connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.addEventListener('keydown', (event) => {
     const details = this.querySelector('details');
     if (event.key === 'Escape' && details?.open) {
      details.open = false;
      details.querySelector('summary')?.focus();
      event.preventDefault();
     }
    }, options);
    document.addEventListener('click', (event) => {
     if (!this.contains(event.target)) this.querySelector('details')?.removeAttribute('open');
    }, options);
   }
   disconnectedCallback() { this.controller?.abort(); }
  });
 }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
